import React, { useContext } from 'react'
import { SearchContext } from '../../contexts/searchContext'
import { useOutsideClick } from '../../hooks/useOutsideClick'
import SearchInput from './SearchInput'
import SearchResult from './SearchResult'
import styles from './styles.module.css'

const Search = () => {
  const { isSearchMobileActive, setIsVisible } = useContext(SearchContext)
  const ref = useOutsideClick(() => setIsVisible(false))

  return (
    <div ref={ref} className={`${styles.searchGroup} ${isSearchMobileActive && styles.active}`}>
      <SearchInput />
      <SearchResult />
    </div>
  )
}

export default Search
